import React from 'react';
import { Modal, Button } from 'rsuite';
import { List, ListItem, ListItemText } from '@mui/material';
import { WidgetDateTime, WidgetAmount, WidgetAccount, WidgetStatus, WidgetTitleSubtitle, WidgetCuit } from '../../../../components';
import statuses from '../../../../constants/transfers/statuses';
import _ from 'lodash';

export default function MovementDetail ({ transfer, show, onHide }) {
    return (
        <Modal
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='transaction-view-modal'
        >
            <Modal.Header>
                <Modal.Title>Detalle de Transaccion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <List>
                    <ListItem>
                        <ListItemText primary='Id de transaccion:' />{transfer.id}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Descripcion:' />{transfer.description}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Id de transaccion padre:' />{transfer.id_parent || 'No posee'}
                    </ListItem>
                    {(transfer.metadata.idsTransferAdjusted || transfer.metadata.idTransferAdjusted) &&
                     <ListItem>
                         <ListItemText primary='Id de transacciones asociadas:' />{_.flatten([transfer.metadata.idsTransferAdjusted || transfer.metadata.idTransferAdjusted]).toString().replaceAll(',', '-') || 'No posee'}
                     </ListItem>}
                    <ListItem>
                        <ListItemText primary='Valor:' />{<WidgetAmount amount={transfer.amount} currency={transfer.currency.attributes.symbol.value} />}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Creado:' />{transfer.created_at ? (<WidgetDateTime date={new Date(transfer.created_at)} />) : ''}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Estado:' />{<WidgetStatus { ...statuses[transfer.status.description] } />}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Tipo:' />{transfer.type.description === 'tax_ar_iibb_tucuman_rg7422' ? 'Perc. IIBB Tucumán RG 74/22' : transfer.type.description}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Moneda:' />{transfer.currency.description}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Cuenta Origen:' />{<WidgetAccount account={transfer.accounts.origin.id} />}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Originante:' />
                        { <WidgetTitleSubtitle
                            title={transfer.userOrigin.formattedName}
                            subtitle={(
                                <WidgetCuit
                                    cuit={_.get(transfer, 'userOrigin.person.cuil.description', 'S/D')}
                                />
                            )} />
                        }
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Cuenta Destino:' />{<WidgetAccount account={transfer?.accounts?.destination?.id} />}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary='Destinatario:' />
                        {<WidgetTitleSubtitle
                            title={_.get(transfer, 'userDestination.formattedName', 'S/D')}
                            subtitle={(
                                <WidgetCuit
                                    cuit={_.get(transfer, 'userDestination.person.cuil.description', 'S/D')}
                                />
                            )}
                        />}
                    </ListItem>
                    {transfer.childs
                        ? transfer.childs.map(child => (
                            <List key={child.id}>
                                <ListItem>
                                    <ListItemText primary='Cuenta Hijo id:' />{child.id}
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary='Cuenta Hijo descripcion:' />{child.description}
                                </ListItem>
                                {/* <ListItem>
                                    <ListItemText primary='Cuenta Hijo tipo:' />{child.type.description}
                                </ListItem> */}
                                <ListItem>
                                    <ListItemText primary='Cuenta Hijo Valor:' />{<WidgetAmount amount={child.amount} currency={child.currency?.attributes.symbol.value || ''} />}
                                </ListItem>
                            </List>
                        )) : ''}
                </List>
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Button appearance='primary' onClick={onHide} >Aceptar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
